export default __webpack_public_path__ + "static/media/photo--lg--group-nice.0428d714.jpg";